import Machine from '../../../../../types/api/machine'

export const PRINTING_MACHINE_TYPE_NAMES = ['platen', 'digital'] as const

export function isPrintingMachine(machine: Machine): boolean {
    const typeName = machine.machine_type?.name

    return PRINTING_MACHINE_TYPE_NAMES.includes(
        typeName as (typeof PRINTING_MACHINE_TYPE_NAMES)[number]
    )
}

export interface MachinesByBrandGroup {
    brand: string
    machines: Machine[]
}

export function groupMachinesByBrand(machines: Machine[]): MachinesByBrandGroup[] {
    const groups = new Map<string, Machine[]>()

    for (const machine of machines) {
        if (!isPrintingMachine(machine)) continue

        const brand = machine.machine_brand?.name || 'Без бренда'

        if (!groups.has(brand)) {
            groups.set(brand, [])
        }

        groups.get(brand)!.push(machine)
    }

    return [...groups.entries()]
        .sort(([brandA], [brandB]) => brandA.localeCompare(brandB, 'ru', { sensitivity: 'base' }))
        .map(([brand, brandMachines]) => ({
            brand,
            machines: brandMachines.sort((a, b) =>
                a.name.localeCompare(b.name, 'ru', { sensitivity: 'base' })
            ),
        }))
}
